import React, { useEffect, useState } from "react";
import { CheckBox } from "devextreme-react";
import LVButtonAccion from "../../../Basicos/LVButtonAccion";
import { function_VEN_Reservas_Cabecera_Leer } from "neftis7_apicaller/src/funciones/VEN/Reservas/VEN_Reservas_Cabecera";
import { function_ABM_EEX_Clientes_Leer } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_Clientes";
import LV_EEX_Participante from "./LV_EEX_Participante.js";
import LV_EEX_Responsable from "./LV_EEX_Responsable.js";
import { validarEMail } from "../../../../funciones/Varios.js";
import { useNavigate } from 'react-router-dom';

//PARTICIPANTE CON AUTORIZACION DE SALTO  
const EXT_IntegranteParticipante = (props) => {
  const navigate = useNavigate();
  const { VEN_Reservas_Detalle: { function_VEN_Reservas_Detalle_Leer } } = require('neftis7_apicaller');
  const { VEN_Reservas_Integrantes: { function_VEN_Reservas_Integrantes_Insertar, function_VEN_Reservas_Integrantes_Generar_JSON } } = require('neftis7_apicaller');
  const [idReserva, setIdReserva] = useState(0);
  const [idItem, setIdItem] = useState(0);
  const [idCliente, setIdCliente] = useState(0);
  const [cuit, setCUIT] = useState("");
  const [idClienteAutorizado, setIdClienteAutorizado] = useState(0);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [puedeGuardar, setPuedeGuardar] = useState(true);
  const [todoCargado, setTodoCargado] = useState(false);
  const [cantidadParticipantes, setCantidadParticipantes] = useState(0);
  const [titulo, setTitulo] = useState("CARGA DE PARTICIPANTES DE RESERVA");
  const [titulo2, setTitulo2] = useState("");
  const [titulo3, setTitulo3] = useState("");
  const linkTerminos = "https://neftis.com.ar/Terminos/" + props.CodigoCompania + "/Terminos.htm"
  const [cierreEnProceso, setCierreEnProceso] = useState(false);
  const [participantesIDs, setParticipantesIDs] = useState([]);

  const handleIdClienteChange = (index, nuevoIdCliente) => {
    setParticipantesIDs(prev => {
      const copia = [...prev];
      copia[index] = nuevoIdCliente;
      return copia;
    });
  };

  const handleOnClickGuardar = async () => {
    if (!termsAccepted) {
      alert("Debe aceptar los términos y condiciones.");
      return;
    }

    const IDsFiltrados = participantesIDs.filter(id => id > 0); // sacamos los 0 por si hay vacíos aún
    const IDsUnicos = new Set(IDsFiltrados);

    if (IDsFiltrados.length !== IDsUnicos.size) {
      alert("Hay participantes repetidos. Verificá que cada DNI sea único.");
      return;
    }

    try {
      for (let i = 0; i < IDsFiltrados.length; i++) {
        const idParticipante = IDsFiltrados[i];

        const Integrante = await function_VEN_Reservas_Integrantes_Generar_JSON(idItem,
          localStorage.getItem("CodigoCompania"), idParticipante, idCliente)

        await function_VEN_Reservas_Integrantes_Insertar(Integrante)
      }

      alert("Has registrado correctamente a los participantes!.");

      window.location.reload()
    } catch (error) {
      alert("Hubo problemas en el registro.");
    } finally {
      setCierreEnProceso(false); // Se habilita el botón de nuevo
    }
  };

  useEffect(() => {
    localStorage.setItem("CodigoCompania", props.CodigoCompania);
    localStorage.setItem("CodigoEmpresa", props.CodigoEmpresa);
    localStorage.setItem("CodigoPlanta", props.CodigoPlanta);
    setIdReserva(props.IdReserva)
    setIdItem(props.IdItem)

    const leerDatos = async () => {
      const item = await function_VEN_Reservas_Detalle_Leer(props.IdReserva, props.IdItem)

      if (item && item.data && item.data.length > 0) {
        const resultCabecera = await function_VEN_Reservas_Cabecera_Leer(props.IdReserva)
        const resultGenerador = await function_ABM_EEX_Clientes_Leer(resultCabecera.data.IdClienteGenerador)
        if (resultGenerador && resultGenerador.data) {
          if (resultGenerador.data.CUIT != "") {
            setCUIT(resultGenerador.data.CUIT)

            if (!validarEMail(resultGenerador.data.Emails)) {
              alert("El E-mail es inválido. Te redireccionaremos para que puedas cambiarlo.")
              navigate("/ReservaIntegranteCambioEMail/" + props.CodigoCompania + "/" + props.CodigoEmpresa + "/" + props.CodigoPlanta + "/" + resultCabecera.data.IdClienteGenerador)
            }

            if (resultGenerador.data.Telefonos == "") {

            }
          } else {
            setTitulo2('Existen problemas con el comprador de la Reserva. Por favor comunicarse telefonicamente con el parque.');
            setTodoCargado(true)
          }
        } else {
          setTitulo2('Existen problemas con el comprador de la Reserva. Por favor comunicarse telefonicamente con el parque.');
          setTodoCargado(true)
        }

        setTitulo('CARGA DE PARTICIPANTES DE RESERVA Nº ' + props.IdReserva)
        setIdCliente(resultCabecera.data.IdClienteGenerador)

        const detalleEncontrado = resultCabecera.data.Detalles.find(det => det.IdItem === Number(props.IdItem));

        setCantidadParticipantes(detalleEncontrado.CantidadParticipantesSinCargar)

        if (detalleEncontrado.CantidadParticipantesSinCargar === 0) {
          setTitulo2('Ya cargaste a todos los participantes! Los esperamos!. Si es necesario realizar cambios en los participantes cargados comunicarse telefonicamente con el parque.');
          setTodoCargado(true)
          setPuedeGuardar(false)
        } else {
          setTitulo2('Participantes sin cargar: ' + detalleEncontrado.CantidadParticipantesSinCargar);
        }

        const nombresClientes = resultCabecera.data.Integrantes
          .filter(integrante => integrante.IdItem === Number(props.IdItem))
          .map(integrante => integrante.Cliente.toUpperCase());

        const titulo3 = nombresClientes.join(', ');
        setTitulo3('Participantes cargados: ' + titulo3);

      } else {
        setPuedeGuardar(false)
        alert("Esta reserva no existe.");
      }
    }
    leerDatos();
  }, []);

  return (
    <table width={'100%'} height={'100%'}>
      <tbody>
        <tr>
          <td style={{ margin: '10px', padding: '5px', textAlign: 'center', fontSize: '30px' }}>
            {titulo} <br /><br />
          </td>
        </tr>

        <tr>
          <td style={{ margin: '10px', padding: '5px', textAlign: 'center', fontSize: '15px' }}>
            {titulo2} <br /><br />
            {titulo3} <br /><br /><br />
          </td>
        </tr>

        {!todoCargado && (
          <>
            <tr>
              <td style={{ margin: '10px', padding: '5px', width: '100%' }} >
                <div className="LV-GroupBox-div">
                  {cuit && <LV_EEX_Responsable CUIT={cuit} />}
                </div>
              </td>
            </tr>

            <tr>
              <td style={{ visibility: todoCargado ? 'hidden' : 'visible', margin: '10px', padding: '5px', textAlign: 'left', fontSize: '14px' }} >
                <br />
                <br />
              </td>
            </tr>

            {Array.from({ length: cantidadParticipantes }).map((_, index) => (
              <tr key={index}>
                <td>
                  <LV_EEX_Participante index={index}
                    onIdClienteChange={(id) => handleIdClienteChange(index, id)} />
                </td>
              </tr>
            ))}

            <tr>
              <td style={{ visibility: todoCargado ? 'hidden' : 'visible', margin: '10px', padding: '5px', textAlign: 'left', fontSize: '14px' }} >
                <br />
                <br />
              </td>
            </tr>

            <tr>
              <td>
                <div style={{
                  background: '#f2b6b6',
                  color: 'darkred',
                  padding: '8px',
                  borderRadius: '6px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                  <CheckBox

                    text="ACEPTO LOS TÉRMINOS y CONDICIONES"
                    value={termsAccepted}
                    onValueChanged={(e) => setTermsAccepted(e.value)}
                  />
                </div>
              </td>
            </tr>
            <tr style={{ height: '20px' }} >
            </tr>
            <tr>
              <td>
                <a href={linkTerminos} target="_blank" rel="noopener noreferrer">TÉRMINOS y CONDICIONES</a>
                <div>
                  <iframe src={linkTerminos} width="100%" height="100px" title="Términos y Condiciones" />
                </div>
              </td>
            </tr>

            <tr>
              <td>
                <LVButtonAccion
                  Disabled={cierreEnProceso}
                  Texto="GUARDAR"
                  Ancho={'100%'}
                  onClick={handleOnClickGuardar}
                  visible={puedeGuardar}
                />
              </td>
            </tr>
          </>
        )}
      </tbody>
    </table>
  );


}

export default EXT_IntegranteParticipante;